import { createFileRoute } from "@tanstack/react-router";
import ServiceAreaOverview from "@/pages/ServiceAreaOverview";
import { hubHead } from "@/lib/route-seo";

export const Route = createFileRoute("/service-area/")({
  head: () => hubHead("/service-area"),
  component: ServiceAreaOverview,
});
